<script setup lang="ts">
import { Skeleton } from '@laam/ui/base';
</script>
<template>
	<div class="flex flex-col py-md gap-md lg:hidden mt-11xl">
		<div class="flex justify-between px-sm">
			<!-- Express Placeholder -->
			<Skeleton class="h-[32px] w-[124px]" />
			<div class="flex gap-md">
				<!-- Sort Placeholder -->
				<Skeleton class="h-[32px] w-[70px]" />
				<!-- All Placeholder -->
				<Skeleton class="h-[32px] w-[78px]" />
			</div>
		</div>
		<div class="flex overflow-scroll px-3xl gap-md no-scrollbar">
			<Skeleton class="h-[32px] w-[124px]" />
			<Skeleton class="h-[32px] w-[78px]" />
			<Skeleton class="h-[32px] w-[70px]" />
			<Skeleton class="h-[32px] w-[70px]" />
		</div>
	</div>
</template>
